// @mui
import { styled } from "@mui/material/styles";
import {
  Grid,
  RadioGroup,
  CardActionArea,
  Typography,
  Box,
  Alert,
  AlertTitle,
} from "@mui/material";
//
import BoxMask from "./BoxMask";
import Iconify from "../../Iconify";
// contexts
import { useTool } from "../../../contexts/ToolContext";
import usePlannerSettings from "../../../contexts/PlannerContext";
// icons
import EditOffIcon from "@mui/icons-material/EditOff";
//
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

const BoxStyle = styled(CardActionArea)(({ theme }) => ({
  height: 72,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.text.disabled,
  border: `solid 1px ${theme.palette.grey[500_12]}`,
  borderRadius: Number(theme.shape.borderRadius) * 1.25,
}));

// ----------------------------------------------------------------------

export default function SettingPlannerSlabs() {
  const { toolName, onChangeTool } = useTool();
  const { line, oldLine, nonVisibleFacesAvailable } = usePlannerSettings();
  const { isSlab, setIsSlab } = useTool();

  const { t, i18n } = useTranslation();

  const handleChange = (e, val) => {
    switch (val) {
      default:
      case "slab":
        setIsSlab(true);
        onChangeTool(100, [[0, 0]], val);
        break;
    }
  };

  const isSelected = (tool) => {
    if (toolName == tool) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <RadioGroup
      name="themePlannerTool"
      value="{toolName}"
      onChange={handleChange}
    >
      <Grid dir="ltr" container spacing={1}>
        {/* {[{tool: "slab", icon: "select-all", name: "Lastre a vista", visible: nonVisibleFacesAvailable}].map((tool, index) => {
          return ( */}
        <Grid
          key="slab"
          item
          xs={5}
          display={nonVisibleFacesAvailable ? "block" : "none"}
        >
          <BoxStyle
            sx={{
              flexDirection: "column",
              ...(isSelected("slab") && {
                color: "primary.main",
                boxShadow: (theme) => theme.customShadows.z20,
              }),
            }}
          >
            <Box>
              <Iconify
                icon={`material-symbols:select-all`}
                width={28}
                height={28}
              />
            </Box>
            <Box>
              <Typography variant="body2">
                {t("settings.drawer.slabs.tool_title")}
              </Typography>
            </Box>
            <BoxMask value="slab" />
          </BoxStyle>
        </Grid>
        <Grid
          key="non-slab"
          item
          xs={7}
          display={nonVisibleFacesAvailable ? "block" : "none"}
        >
          <Grid direction="column" container spacing={1} justifyContent="center" sx={{ minHeight: "100%" }}>
            <Grid
              key="non-slab-first"
              item
              xs={6}
              display={nonVisibleFacesAvailable ? "flex" : "none"}
              sx={{ alignItems: "center" }}
            >
              <Box sx={{ minWidth: "35px", height: "5px", backgroundColor: "#C00000" }} />
              <Typography variant="body2" sx={{ paddingLeft: 1, lineHeight: 1.1 }}>
                {line === 10
                  ? oldLine === 2
                    ? t("settings.drawer.slabs.deselect_metal")
                    : t("settings.drawer.slabs.select_metal_1")
                  : ""}
                {line === 3 ? t("settings.drawer.slabs.select_stone_1") : ""}
              </Typography>
            </Grid>
            <Grid
              key="non-slab-second"
              item
              xs={6}
              display={nonVisibleFacesAvailable ? "flex" : "none"}
              sx={{ alignItems: "center" }}
            >
              <Box sx={{ minWidth: "35px", height: "5px", backgroundColor: "#666666" }} />
              <Typography variant="body2" sx={{ paddingLeft: 1, lineHeight: 1.1 }}>
                {line === 10
                  ? oldLine === 2
                    ? t("settings.drawer.slabs.deselect_metal")
                    : t("settings.drawer.slabs.select_metal_2")
                  : ""}
                {line === 3 ? t("settings.drawer.slabs.select_stone_2") : ""}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          key="slabb"
          item
          xs={6}
          display={nonVisibleFacesAvailable && isSlab ? "block" : "none"}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="body2" sx={{ lineHeight: "200%", pb: 1 }}>
              {t('settings.drawer.slabs.hidden_faces')}
            </Typography>
            <Box
              component="img"
              src="../../../assets/images/lastre_a_vista_no.jpeg"
              sx={{ width: "120px" }}
            />
          </Box>
        </Grid>
        <Grid
          key="slab-2"
          item
          xs={6}
          display={nonVisibleFacesAvailable && isSlab ? "block" : "none"}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="body2" sx={{ lineHeight: "200%", pb: 1 }}>
              {t('settings.drawer.slabs.visible_faces')}
            </Typography>
            <Box
              component="img"
              src="../../../assets/images/lastre_a_vista_si.jpeg"
              sx={{ width: "120px" }}
            />
          </Box>
        </Grid>
        {/* <Grid key="slab-desc" item xs={12} display={nonVisibleFacesAvailable && isSlab ? "block" : "none"}>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "left", justifyContent: "center" }}>
                <Alert severity="warning">
                  <AlertTitle>Attenzione</AlertTitle>
                  <Typography variant="italic" component="p" sx={{ lineHeight: "120%" }}>Le facce tra due blocchi di altezza differente hanno lastre a vista applicate, preselezionate e obbligatorie.</Typography>
                  <Typography variant="italic" component="p" sx={{ lineHeight: "100%" }}>Completa le altre facce a tua scelta con lastre a vista.</Typography>
                </Alert>
              </Box>
            </Grid> */}
        {/* );
        })} */}
      </Grid>
    </RadioGroup>
  );
}
